import { AuthInfoModel, ContextModel, LimitPriceModel, InsuranceModel } from "models";
import React from "react";
import { Link, NavLink } from "react-router-dom";
import Image from "./images/Image";
import { Utils } from "utils";

const InnerAreaCorpInfo: React.FC<{
  data?: AuthInfoModel;
  limitPrice?: LimitPriceModel;
}> = ({ data, limitPrice }) => {
  if (!data) {
    return <></>;
  }

  const insuranceList = limitPrice?.insurance_list;
  const iframe = insuranceList && insuranceList.filter(
    (insurance: InsuranceModel) => (insurance.order_balance ?? 0) > 0 ).length > 1 ? true : false;
  const iframeWidth = iframe ? "1.7fr" : "1fr";
  return (
    <div className="w-full flex flex-col items-center">
      {data.corp_logo && data.corp_logo.image_url && (
        <div className="w-1/2">
          <Image data={data.corp_logo} />
        </div>
      )}
      <div className="my-2 px-3 truncate" title={data.corp_name}>
        {data.corp_name}
      </div>
      {limitPrice && (
         <div
           className="grid grid-rows-2 gap-x-2"
           style={{ gridTemplateColumns: `${iframeWidth} auto 1fr` }}
         >
          <div className="whitespace-nowrap text-right">発注可能額</div>
          <span>/</span>
          <div className="whitespace-nowrap">発注限度額</div>
          {!limitPrice.is_insurance_request_status ? (
            (insuranceList && insuranceList.length > 0) && (
              insuranceList
                .filter(
                  (insurance: InsuranceModel) => (insurance.order_limit ?? 0) > 0
                )
                .map((insurance: InsuranceModel, index: number) => {
                  const fullName = insurance.display_name ?? "";
                  const formattedName = `${Utils.addComma(fullName, false)}`;

                  let displayName = fullName;
                  if (fullName.length > 10) {
                    displayName = fullName.substring(0, 10) + "...";
                  } else {
                    displayName = fullName;
                  }

                  const orderBalanceStr = String(insurance.order_balance ?? 0);
                  const orderBalanceDigits = orderBalanceStr.replace(/[^0-9]/g, '').length;

                  displayName = orderBalanceDigits > 8 && fullName.length > 5 ? fullName.substring(0,5) + "..." : displayName;


                  return (
                    <React.Fragment key={index}>
                      <div className="flex justify-end items-center overflow-hidden whitespace-nowrap">
                        { insuranceList.filter(
                          (insurance: InsuranceModel) => (insurance.order_balance ?? 0) > 0 ).length > 1 ? (
                            <span className="overflow-hidden text-ellipsis whitespace-nowrap"
                               title={formattedName}
                            >{displayName}&nbsp;</span>
                          ) : null}
                        {insurance.order_balance
                          ? `${Utils.addComma(insurance.order_balance, false)}円`
                          : "未設定"}
                      </div>
                      <span>/</span>
                      <div className="whitespace-nowrap">
                        {Utils.addComma(insurance.order_limit, false)}円
                      </div>
                    </React.Fragment>
                  );
                })
            )
          ) : (
            <>
              <div className="whitespace-nowrap text-right">
                {limitPrice.order_now_limit ? `${Utils.addComma(limitPrice.order_now_limit, false)}円` : '未設定'}
              </div>
              <span>/</span>
              <div className="whitespace-nowrap">
                {Utils.addComma(limitPrice.order_limit, false)}円
              </div>
            </>
          )}
        </div>
      )}
      <div className="py-8">
        {data.is_register_profile && (
          // 会社ページへのリンクは、CorpProfileが登録済みの場合のみ表示
          <Link to={`/company-detail/${data.corp_id}/`}>
            <button className="secondary p-2">会社ページを見る</button>
          </Link>
        )}
      </div>
    </div>
  );
};

type PROPS = {
  ctx: ContextModel;
  data?: AuthInfoModel;
};

const SideMenu: React.FC<PROPS> = (props) => {
  const admin = props.ctx.auth.data?.is_admin_corp;

  return (
    <div className="jhk-sidemenu flex flex-col items-center py-8 border border-r w-80 bg-slate-200 overflow-y-auto">
      <InnerAreaCorpInfo
        data={props.data}
        limitPrice={props.ctx.limitPrice.data}
      />

      <div className="flex flex-col gap-2">
        <NavLink to="/mypage/" className="">
          マイページトップ
        </NavLink>
        {admin ? (
          <>
            <NavLink to="/company-category/">会社カテゴリ設定</NavLink>
            <NavLink to="/item-category/">商品カテゴリ設定</NavLink>
            <NavLink to="/thread-list/">掲示板管理</NavLink>
          </>
        ) : (
          <>
            <NavLink to="/company-info/">会社情報設定</NavLink>
            <NavLink to="/public-relations/">会社PR設定</NavLink>
            {props.data?.is_register_profile && (
              // CorpProfile情報が入力済みの場合のみ表示
              <NavLink to="/exhibit-list?get_count=10">出品一覧</NavLink>
            )}
            <NavLink to="/non-disclosure-list/">非公開リスト一覧</NavLink>
            <NavLink to="/limited-disclosure-list/">限定公開リスト一覧</NavLink>
            <NavLink to="/favorite-company?get_count=10">お気に入り会社一覧</NavLink>
            <NavLink to="/favorite-item?get_count=10">お気に入り商品一覧</NavLink>
            <NavLink to="/talk-list?get_count=10">見積依頼・お問い合わせ一覧</NavLink>
          </>
        )}
      </div>
    </div>
  );
};

export default SideMenu;
